module.exports = __webpack_public_path__ + "img/Cookie_1_resize_35.745baf09.png";